// JS unico del tema. Cada bloque se auto-desactiva si su markup no esta en la pagina.

// --- Drawer (todas las paginas) ---
const drawer = document.getElementById('drawer');
if (drawer) {
  document.querySelectorAll('[data-menu]').forEach(b => b.onclick = () => drawer.classList.add('open'));
  document.querySelectorAll('[data-menu-close]').forEach(b => b.onclick = () => drawer.classList.remove('open'));
  drawer.addEventListener('click', e => { if (e.target === drawer) drawer.classList.remove('open') });
}

// --- Reveals on scroll (patron .seen del proyecto) ---
const io = new IntersectionObserver(es => es.forEach(e => e.isIntersecting && e.target.classList.add('seen')), { threshold: .3 });
document.querySelectorAll('.reveal, .pshot, .infob, .how, .facts li').forEach(el => io.observe(el));

// --- Galeria del producto ---
const main = document.getElementById('galMain');
const thumbs = [...document.querySelectorAll('#thumbs button')];
let cur = 0;
function show(i) {
  if (!thumbs.length) return;
  cur = (i + thumbs.length) % thumbs.length;
  // data-full trae la version grande; el <img> del thumb es la chica.
  main.src = thumbs[cur].dataset.full || thumbs[cur].querySelector('img').src;
  thumbs.forEach((t, j) => t.classList.toggle('on', j === cur));
}
if (main && thumbs.length) {
  thumbs.forEach((t, i) => t.onclick = () => show(i));
  document.querySelectorAll('[data-gal]').forEach(b => b.onclick = () => show(cur + +b.dataset.gal));
}

// --- Selector de packs = selector de variante ---
const packs = [...document.querySelectorAll('.pack')];
if (packs.length) {
  const variantInput = document.querySelector('[data-variant-input]');
  const gifts = document.getElementById('gifts');
  const sPrice = document.getElementById('sticky-price');
  const sTitle = document.getElementById('sticky-title');
  const sStrike = document.getElementById('sticky-strike');

  function selectPack(pack) {
    packs.forEach(p => p.classList.toggle('on', p === pack));
    if (variantInput) variantInput.value = pack.dataset.variantId;
    if (gifts) gifts.hidden = !pack.dataset.gifts;
    if (sPrice) sPrice.textContent = pack.dataset.price;
    if (sTitle) sTitle.textContent = pack.dataset.title;
    if (sStrike) sStrike.textContent = pack.dataset.compare || '';
    // Deja el ?variant= en la URL: compartir el link conserva el pack elegido.
    const url = new URL(location);
    url.searchParams.set('variant', pack.dataset.variantId);
    history.replaceState({}, '', url);
  }
  packs.forEach(p => p.onclick = () => selectPack(p));
  const active = document.querySelector('.pack.on');
  if (active) selectPack(active);
}

// --- Barra sticky del producto: aparece al llegar a "Como funciona" ---
const sticky = document.getElementById('sticky');
const como = document.getElementById('como');
if (sticky && como) {
  const stickyIo = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { sticky.classList.add('show'); stickyIo.disconnect() }
  }), { threshold: 0 });
  stickyIo.observe(como);
}

// --- CTA fija de la home: visible fuera del hero, se esconde en #producto ---
const mcta = document.getElementById('mcta');
const hero = document.querySelector('.h1full');
const prod = document.getElementById('producto');
if (mcta && hero && prod) {
  new IntersectionObserver(es => es.forEach(e => mcta.classList.toggle('show', !e.isIntersecting)), { threshold: 0 }).observe(hero);
  new IntersectionObserver(es => es.forEach(e => e.isIntersecting && mcta.classList.remove('show')), { threshold: .6 }).observe(prod);
}

if (window.lucide) lucide.createIcons({ attrs: { 'stroke-width': 1.5 } });
